var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGiftIcon = function SvgGiftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    d: "M31.62 15.834H6.285v12.667c0 4.75 1.583 6.333 6.333 6.333h12.667c4.75 0 6.333-1.583 6.333-6.333V15.834ZM34.042 11.083v1.583c0 1.742-.84 3.167-3.167 3.167H7.125c-2.422 0-3.167-1.425-3.167-3.167v-1.583c0-1.742.745-3.167 3.167-3.167h23.75c2.328 0 3.167 1.425 3.167 3.167Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    d: "M18.43 7.916H9.69a1.483 1.483 0 0 1 .048-2.058l2.248-2.249a1.52 1.52 0 0 1 2.137 0l4.307 4.307ZM28.294 7.916h-8.74l4.307-4.307a1.52 1.52 0 0 1 2.137 0l2.249 2.249c.57.57.585 1.472.047 2.058ZM14.155 15.834v8.138c0 1.267 1.393 2.011 2.454 1.33l1.488-.981a1.582 1.582 0 0 1 1.742 0l1.41.95c1.044.696 2.453-.048 2.453-1.315v-8.122h-9.547Z",
    opacity: 0.4
  })));
};
export default SvgGiftIcon;